import { useInternalState, assignMswData, serializeQuery } from '../hooks/internalState';
import {
  PostVideoReportResult,
  PostVideoReportOptions,
  PostVideoReportFields,
  postVideoReport,
} from '../fetchers/video/report';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';
import { useGctlConfig } from '../hooks/GctlProvider';

/**
 * DO NOT MODIFY
 * Auto-generated by gctl-plugin-vimeo-hooks
 */

type UsePostVideoReportOptions<Fields extends PostVideoReportFields> =
  PostVideoReportOptions<Fields>;

/**
 * Flag a video
 * This method flags the specified video.
 */

export function usePostVideoReport<Fields extends PostVideoReportFields>() {
  const { mutate } = useSWRConfig();
  let { baseUrl, jwt, xVimeoPage, locale } = useGctlConfig();

  let [state, dispatch] = useInternalState<PostVideoReportResult<Fields> | undefined>();

  let call = useCallback(
    async (options: UsePostVideoReportOptions<Fields>) => {
      dispatch({ type: 'REQUEST' });

      try {
        let result = await mutate(
          `/videos/${options.where.videoId}/report${serializeQuery(options)}`,
          postVideoReport({
            ...options,
            baseUrl,
            headers: {
              ...options.headers,
              'Content-Type': 'application/json',
              Authorization: jwt ? `jwt ${jwt}` : '',
              'Vimeo-Page': `${xVimeoPage}`,
              'Accept-Language': locale ?? 'en',
            },
          }),
          false,
        );

        dispatch({ type: 'SUCCESS', payload: result });
      } catch (err) {
        dispatch({ type: 'FAILURE', payload: err });
      }
    },
    [baseUrl, xVimeoPage, jwt, locale, dispatch],
  );

  return [call, state] as const;
}

if (process.env.NODE_ENV !== 'production' || process.env.STORYBOOK === 'true') {
  assignMswData(usePostVideoReport, {
    endpoint: '/videos/:videoId/report',
    method: 'POST',
  });
}
